import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Logistiques } from '../../logistiques';
import { LogistiquesService } from '../../logistiques.service';

@Component({
  selector: 'app-parc-auto-convoyeur',
  templateUrl: './parc-auto-convoyeur.component.html',
  styleUrls: ['./parc-auto-convoyeur.component.css']
})
export class ParcAutoConvoyeurComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user'));
  subscription: Subscription = new Subscription();
  @Input() id: string;
  v: Logistiques;
  form: FormGroup;
  submitted = false;
  loading = true;
  errorMsg = '';

  constructor(
    private modal: NgbModal,
    private fb: FormBuilder,
    private service: LogistiquesService
  ) { }

  ngOnInit(): void {
    this.getVehicule(this.id);
    this.createForm();
  }

  getVehicule(id: string): void {
    this.subscription.add(
      this.service.view('vehicules', id)
        .subscribe(arg => {
          this.v = arg;
          this.loading = false;
        })
    );
  }

  open(c: any): void {
    this.modal.open(c);
  }

  createForm(): void {
    this.form = this.fb.group({
      convoyeur: ['', Validators.required],
      mobile: ['', Validators.required],
      piece: ['', Validators.required],
      pin: ['', [Validators.required, Validators.pattern('^[0-9]{4}$')]]
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.update('convoyeurs', this.id, this.form.value)
        .subscribe(
          arg => {
            this.getVehicule(this.id);
            this.modal.dismissAll();
            this.submitted = false;
          },
          erg => {
            this.errorMsg = erg.error.message;
            this.submitted = false;
          })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
